import { useStoreApi } from "reactflow"

import { useFormik } from "formik"
import type { FormikProps } from "formik"

import type { FeatureMapping, FeatureMappingFormikValues, SelectionDataItemType } from "../../types/interfaces"

interface UseSelectionNodeFormProps {
  data?: {
    feature_mappings?: FeatureMapping[]
    project?: { uuid: string }
    nodeType?: string
  }
  nodeId: string | null
  currentDataItemId: () => string | undefined | SelectionDataItemType
}

/**
 * useSelectionNodeForm hook that manages form state for selection node configuration.
 * Handles feature mapping and project selection for workflow nodes.
 */
export const useSelectionNodeForm = ({
  data,
  nodeId,
  currentDataItemId,
}: UseSelectionNodeFormProps): FormikProps<FeatureMappingFormikValues> => {
  // React Flow hooks
  const store = useStoreApi()
  const { setNodes, getNodes } = store.getState()

  return useFormik<FeatureMappingFormikValues>({
    initialValues: {
      feature_mappings: data?.feature_mappings ?? [],
      retrievedNode: {
        uuid: data?.project?.uuid as string,
        feature_mappings: data?.feature_mappings as Array<FeatureMapping>,
      },
      liveModelSchema: [],
      cachedNodes: {},
    },

    onSubmit: async ({ feature_mappings }) => {
      // Update node state with feature mappings
      setNodes(
        getNodes().map((node) => {
          const newNode = { ...node }

          if (node.id === nodeId && data?.nodeType === "ProjectNode" && currentDataItemId()) {
            return {
              ...newNode.data,
              feature_mappings: feature_mappings,
            }
          }
          return newNode
        }),
      )
    },
  })
}
